import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { validatePhone } from '@debbie/common/dist/index.js';
import { getLocale, locales } from '@debbie/common/dist/phone/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { Input, SearchInput } from './index.js';
const PhoneInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const [phone, setPhone] = useState({
        number: (props.phone && props.phone.number) || '',
        locale: (props.phone && props.phone.locale) ||
            (tenant != null
                ? getLocale(tenant.countryCode, props.phone?.number)
                : '45'),
    });
    const save = (_phone) => {
        const phoneData = _phone || phone;
        const p = {
            locale: phoneData && phoneData.locale,
            number: phoneData && washNumber(phoneData.number),
        };
        const valid = validatePhone(p);
        if (props.onChange) {
            props.onChange(valid || props.noSaveOnValid ? p : null);
            setPhone(p);
        }
    };
    useEffect(() => {
        if (props.noSaveOnValid && props.phone && (!phone || phone.number === '')) {
            save(props.phone);
        }
    }, []);
    return (React.createElement(PhoneInputWrapper, null,
        React.createElement(SearchInput, { containerStyle: { width: `${100}px` }, disabled: props.disabled, inputStyle: props.style, placeholder: "\u260E", searchAll: (q) => locales
                .filter((locale) => `+${locale.locale} ${locale.country}`
                .toLowerCase()
                .indexOf(q.toLowerCase()) !== -1 || q.length === 0)
                .map((locale) => ({
                key: locale.locale + locale.country,
                heading: locale.country,
                subheading: `+${locale.locale} ${locale.country}`,
                returnData: locale.locale,
            })), static: phone && phone.locale && `+${phone.locale}`, onSelect: (locale) => {
                const newPhone = {
                    ...phone,
                    locale,
                };
                setPhone(newPhone);
                if (props.noSaveOnValid)
                    save(newPhone);
            }, onRemoveStatic: () => {
                const newPhone = {
                    ...phone,
                    locale: null,
                };
                setPhone(newPhone);
                if (props.noSaveOnValid)
                    save(newPhone);
            }, forceOpen: true }),
        React.createElement(Input, { containerStyle: {
                flexGrow: '1',
                marginLeft: '20px',
            }, disabled: props.disabled, style: props.style, autofocus: props.autofocus, value: (phone && phone.number) || '', onChange: (e) => {
                const newPhone = {
                    ...phone,
                    number: e.target.value,
                };
                setPhone(newPhone);
                if (props.noSaveOnValid)
                    save(newPhone);
            }, onKeyDown: (e) => {
                if (e.key === 'Enter' && !props.noSaveOnValid) {
                    save();
                }
            }, placeholder: lang.inputs.phoneNumber, button: ((props.phone && props.phone.number) != (phone && phone.number) ||
                (props.phone && props.phone.locale) != (phone && phone.locale)) &&
                !props.noSaveOnValid
                ? {
                    value: lang.collectors.updateEntity,
                    loading: props.loading,
                    onClick: () => save(),
                }
                : undefined })));
};
const washNumber = (number) => typeof number === 'string' ? number.replace(/[^0-9]+/g, '') : null;
export default PhoneInput;
const PhoneInputWrapper = styled.div `
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=PhoneInput.js.map